import initialState from '../constants/initialState';
import * as types from '../constants/types';

export default (state = initialState.auth, action) => {
	switch (action.type) {
		case types.auth.LOGIN:
			return {
				...state,
				isAuth: true,
				isAdmin: action.payload.user.role === 0 ? true : false,
				//isAdmin: true,
				user: action.payload.user,
				token: action.payload.token,
			};
		case types.auth.REGISTER:
			return {
				...state,
				isAuth: true,
				user: action.payload.user,
				token: action.payload.token,
			};
		case types.auth.LOGOUT:
			return {
				...state,
				isAuth: false,
				isAdmin: false,
				user: null,
				token: null,
			};
		default:
			return state;
	}
};
